import { Component, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { UpdateService } from './features/update/services/update.service';
import { TextZoom } from '@capacitor/text-zoom';
import { StorageService } from './core/services/storage.service';
import { Capacitor } from '@capacitor/core';
import { Gleap } from 'capacitor-gleap-plugin';
import { AuthService } from './core/auth/services/auth.service';
import { NotificationsService } from './core/services/notifications.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent {
	constructor(
		private router: Router,
		private zone: NgZone,
		private storageService: StorageService,
		private updateService: UpdateService,
		private authService: AuthService,
		private notificationsService: NotificationsService
	) {
		this.trackLastRoute();
		this.initializeApp();
	}
	
	private trackLastRoute() {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.storageService.set('lastRoute', event.urlAfterRedirects);
			}
		});
	}

	async setStatusBar() {
		await StatusBar.setOverlaysWebView({ overlay: false });
		await StatusBar.setBackgroundColor({ color: '#162a62' });
		await StatusBar.setStyle({ style: Style.Dark });
	}

	async initializeApp() {
	
		App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
			this.zone.run(() => {
				const slug = event.url.split(".app").pop();
				if (slug) {
					this.router.navigateByUrl(slug);
				}

			});
		});

		App.addListener('appStateChange', ({ isActive }) => {
			if (isActive) {
				this.checkUpdates();
			}
		});

		if (Capacitor.getPlatform() !== 'web') {
			this.setStatusBar();
			TextZoom.set({ value: 1.0 });
		}
		const user = this.authService.currentUserFromToken;

		if(user && user.id){
			Gleap.identify({
				userId: user.id ?? '',
				name: (user.companyName) ? user.companyName : `${user.firstName} ${user.lastName}`,
				email: user.email,
				companyName: user.companyName,
			});
			
			// Inicializar push notifications para usuarios autenticados
			await this.notificationsService.initPushNotifications();
		}
		
		this.checkUpdates();
	}

	checkUpdates() {
		if (Capacitor.getPlatform() !== 'web') {
			this.updateService.checkUpdates();
		}
	}
}
